import React from 'react';
import { Menu, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { BrandButton } from '../button';
import { acme } from '../../theme/acmeTheme';

const menuPaperSx = {
  mt: 1.5,
  width: 340,
  maxWidth: 340,
  maxHeight: 400,
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
  '&:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: -10,
    right: 14,
    width: 20,
    height: 20,
    bgcolor: 'background.paper',
    transform: 'rotate(45deg)',
    zIndex: 0
  }
};

const footerSx = {
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#FFFFFF',
  zIndex: 1,
  p: 1.5,
  borderTop: '1px solid rgba(0,0,0,0.08)',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px'
};

const viewAllSx = {
  textTransform: 'none',
  fontWeight: 600,
  width: '100%',
  borderRadius: '8px',
  py: 0.75,
  border: '2px solid #fff'
};

/**
 * Shared dropdown shell for MessageBell / NotificationBell (MUI Menu + header + scroll + footer).
 */
export default function BellDropdownMenu({
  anchorEl,
  onClose,
  titleLabel,
  unreadCount,
  showFooter,
  footerTo,
  footerLabel,
  children
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        elevation: 4,
        sx: menuPaperSx
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          px: 2,
          py: 1.5,
          fontWeight: 600,
          borderBottom: '1px solid rgba(0,0,0,0.06)',
          color: acme.colors.brand
        }}
      >
        {titleLabel}
        {unreadCount > 0 && ` (${unreadCount} unread)`}
      </Typography>

      <Box sx={{ flexGrow: 1, overflowY: 'auto', maxHeight: 300 }}>{children}</Box>

      {showFooter && (
        <Box sx={footerSx}>
          <BrandButton
            tone="accent"
            component={Link}
            to={footerTo}
            sx={viewAllSx}
            onClick={onClose}
          >
            {footerLabel}
          </BrandButton>
        </Box>
      )}
    </Menu>
  );
}
